import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { cn } from "@/shared/lib/utils";
export interface AeroHero3Props {
  backgroundImageUrl: string;
  className?: string;
  ctaHref: string;
  ctaLabel: string;
  description: string;
  id?: string;
  eyebrow?: string;
  title: string;
}
export function AeroHero3(t0) {
  const $ = _c(34);
  const {
    backgroundImageUrl,
    className,
    ctaHref,
    ctaLabel,
    description,
    id,
    eyebrow,
    title
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden bg-[#122023]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden h-full w-full grid-cols-12 divide-x divide-white/15 md:grid"><div className="col-span-1 h-full" /><div className="col-span-3 h-full" /><div className="col-span-4 h-full" /><div className="col-span-3 h-full" /><div className="col-span-1 h-full" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-0 z-10 size-full">{t2}<div className="grid h-full w-full grid-cols-6 divide-x divide-white/10 md:hidden"><div className="col-span-1 h-full" /><div className="col-span-1 h-full" /><div className="col-span-2 h-full" /><div className="col-span-1 h-full" /><div className="col-span-1 h-full" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `url(${backgroundImageUrl})`;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      backgroundImage: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(4,12,14,0.35)_0%,rgba(4,12,14,0.58)_38%,rgba(4,12,14,0.72)_100%)]" />;
    t7 = <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(21,90,125,0.5),transparent_32%)]" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5) {
    t8 = <div className="absolute inset-0 bg-cover bg-center" style={t5}>{t6}{t7}</div>;
    $[8] = t5;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== eyebrow) {
    t9 = eyebrow ? <p className="mb-6 rounded-full border border-white/20 bg-white/8 px-4 py-2 text-xs font-medium tracking-[0.32em] text-white/80 uppercase backdrop-blur-sm">{eyebrow}</p> : null;
    $[10] = eyebrow;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== title) {
    t10 = <h1 className="max-w-7xl font-heading text-5xl font-normal tracking-tight text-balance md:text-6xl lg:text-[80px]">{title}</h1>;
    $[12] = title;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== description) {
    t11 = <p className="mx-auto mt-6 mb-10 max-w-2xl text-base font-light text-pretty text-white/88 md:text-lg lg:text-xl">{description}</p>;
    $[14] = description;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== ctaHref) {
    t12 = <Link href={ctaHref} />;
    $[16] = ctaHref;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== ctaLabel) {
    t13 = <span className="rounded-full bg-primary px-6 py-3 text-primary-foreground transition-colors duration-500 ease-in-out group-hover:bg-secondary group-hover:text-secondary-foreground">{ctaLabel}</span>;
    $[18] = ctaLabel;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="relative flex h-fit items-center overflow-hidden rounded-full bg-primary p-5 text-primary-foreground transition-colors duration-500 ease-in-out group-hover:bg-secondary group-hover:text-secondary-foreground"><ArrowUpRight className="absolute h-5 w-5 -translate-x-1/2 transition-all duration-500 ease-in-out group-hover:translate-x-10" /><ArrowUpRight className="absolute h-5 w-5 -translate-x-10 transition-all duration-500 ease-in-out group-hover:-translate-x-1/2" /></span>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t13) {
    t15 = <Button className="group mx-auto flex cursor-pointer items-center justify-center gap-0 rounded-full border-none bg-transparent px-0 py-5 font-normal shadow-none hover:bg-transparent [:hover,[data-pressed]]:bg-transparent" render={t12}>{t13}{t14}</Button>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t15 || $[27] !== t9) {
    t16 = <div className="relative z-20 mx-auto flex w-full max-w-6xl flex-col items-center px-6 py-24 text-center text-white sm:px-10 lg:px-12">{t9}{t10}{t11}{t15}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t15;
    $[27] = t9;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== id || $[30] !== t1 || $[31] !== t16 || $[32] !== t8) {
    t17 = <section id={id} className={t1}>{t3}{t8}{t16}</section>;
    $[29] = id;
    $[30] = t1;
    $[31] = t16;
    $[32] = t8;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
export { AeroHero3 as Component };